<!--
 * @Author: zhaoyang
 * @Date: 2024-02-24 12:42:20
 * @Last Modified by: zhaoyang
 * @Last Modified time: 2024-02-29 11:10:45
-->

<template>
    <register-layout>
        <div class="register-left">
            <div class="title">
                以下のフォームから会員仮登録のお申し込みができます
            </div>

            <div class="desc">
                仮登録完了後ご入力頂いたメールアドレスへ本会員登録のご案内を配信します。
            </div>
            <div
                class="desc"
                style="margin-top: 0;"
            >
                ※自動配信メールが届かない場合は、「インスタキャッシュ」のドメイン（instachsh.jp）を許可する設定になっているかご確認ください。
            </div>

            <div class="sub-tip-wrap">
                <span class="fa-ren">🪧 法人のお客様へ</span>
                <div
                    v-for="txt in tipSub"
                    :key="txt"
                    class="sub-tip"
                >
                    {{ txt }}
                </div>
            </div>

            <div class="desc">
                <span>会員登録にはこちらのブラウザを推奨します。</span>
                <img
                    src="./img/safari.png"
                    alt=""
                    class="icon"
                >
                <img
                    src="./img/chrome.png"
                    alt=""
                    class="icon"
                >
            </div>

            <div
                v-if="!isServer && form"
                class="form-wrap"
            >
                <a-form
                    class="form"
                    layout="vertical"
                    :form="form"
                >
                    <a-form-item
                        label="メールアドレス"
                        style="width: 53%;"
                    >
                        <a-input
                            v-decorator="['ema', {rules: [{required: true, message: ' '}]}]"
                            placeholder="xukejp@yahoo.co.jp"
                            style="width: 92%;"
                        />
                    </a-form-item>
                    <a-form-item
                        label="メールアドレス確認"
                        style="width: 47%;"
                    >
                        <a-input
                            v-decorator="['emaMust', {rules: [{required: true, message: ' '}]}]"
                            placeholder="xukejp@yahoo.co.jp"
                        />
                    </a-form-item>
                    <a-form-item
                        label="パスワード"
                        style="width: 53%;"
                    >
                        <a-input
                            v-decorator="['pwd', {rules: [{required: true, message: ' '}]}]"
                            placeholder="Qwer1234!"
                            style="width: 92%;"
                        />
                    </a-form-item>
                    <a-form-item
                        label="パスワード確認"
                        style="width: 47%;"
                    >
                        <a-input
                            v-decorator="['pwdMust', {rules: [{required: true, message: ' '}]}]"
                            placeholder="Qwer1234!"
                        />
                    </a-form-item>

                    <a-form-item
                        label="秘密の質問"
                        style="width: 53%;"
                    >
                        <a-radio-group
                            v-decorator="[
                                'secret',
                                { rules: [{ required: true, message: ' ' }] },
                            ]"
                            class="custom-btn-radio-group"
                            style="width: 92%;"
                        >
                            <a-radio-button value="好きな食べ物">
                                好きな食べ物
                            </a-radio-button>
                            <a-radio-button
                                value="趣味"
                                style="flex: unset; min-width: 0.68rem;"
                            >
                                趣味
                            </a-radio-button>
                            <a-radio-button
                                value="母の旧姓"
                                style="flex: unset; min-width: 0.96rem;"
                            >
                                母の旧姓
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item
                        label="その答え"
                        style="width: 47%;"
                    >
                        <a-input
                            v-decorator="['secretAnswer', {rules: [{required: true, message: ' '}]}]"
                        />
                    </a-form-item>
                </a-form>
                <div class="agree-title">
                    <span class="title-left">以下の同意事項を</span><span class="title-right">お読みいただき、同意してください。</span>
                </div>

                <div
                    v-for="(item, idx) in agreementList"
                    :key="idx"
                    :info="item"
                >
                    <agreement
                        style="margin-bottom: 0.33rem;"
                        :info="item"
                        @check="onCheck(idx)"
                    />
                </div>

                <div
                    class="btn"
                    :class="{active: canSubmit}"
                    @click="handleSubmit"
                >
                    送信
                </div>
                <!-- <div class="info">
                    <div
                        v-for="text in infoList"
                        :key="text"
                        class="info-text"
                    >
                        {{ text }}
                    </div>
                </div> -->
            </div>
        </div>
        <template #tip>
            <div class="tip">
                <span>以下に該当するお客様は、</span>
                <span class="red">ご利用になれません。</span>
                <span>予めご了承ください</span>
            </div>
            <div
                v-for="item in tipList"
                :key="item"
                class="tip-list"
            >
                {{ item }}
            </div>
            <div
                class="b3"
                style="margin-top: 0.15rem;"
            >
                こ不明点等がありましたらお間い合わせよりこ連絡下さい。
            </div>
        </template>
    </register-layout>
</template>

<script>
import {isServer} from 'ssr-common/constant/config';

import RegisterLayout from '../component/register-layout';
import Agreement from './component/agreement.vue';

export default {
    name: 'RegisterStep1',

    components: {
        RegisterLayout,
        Agreement
    },

    data() {
        return {
            tipSub: [
                '所在地が国内の法人のお客様は会員仮登録のお申し込みができます。',
                'ご連絡先の氏名及びメールアドレスを明記し履歴事項証明書（発効後３か月以内）を下記までご提出下さい。',
                'info@〇〇.jp'
            ],
            tipList: [
                'マイナンバーをお持ちでない個人の方',
                '非居住者の方',
                '20歳未満の方·75歲以上の方'
            ],
            canSubmit: false,
            isServer: isServer(),
            form: null,
            formData: null,
            agreementList: [
                {
                    showCheck: false,
                    isCheck: false,
                    text: 'ウェブサイト利用規約',
                    desc: 'インスタキャッシュのインターネット上のサイト（以下、「当ウェブサイト」）及び提供システムで提供するすべてのサービスは、下記の利用規約を承諾いただいた方にのみ提供するサービスです。なお、サービスを利用することによって、本規約の内容を承諾いただいたものとみなしますので、ご注意下さい。また、本規約の内容は必要に応じてお客様への通知無く変更することがございますので、随時本ページに掲載されております最新の利用規約をご自身でご参照いただくようお願いいたします。\n\n**第1条　規約の適用**\n\n本規約はインスタキャッシュ株式会社（以下、「当社」といいます）が提供する各種サービスの利用\n\nに対して適用されます。本規約とは別に、当社が別途定める諸規定等が存在する場合は、その規定に\n\n従っていただきます。\n\n**第2条　顧客登録の際の注意事項**\n\n各種サービスの利用をご希望なさる方は、まず顧客登録が必要となります。当ウェブサイト上の指示\n\nに従って所定の設問に当ウェブサイト上で応答していただくことで顧客登録が完了します（登録が完\n\n了したお客様を以下「顧客」といいます。）が、その際には以下の条件をお守りください。\n\n(1) 所定の設問にご自身に関する真実かつ正確なデータを入力すること。\n\n(2) 上記の登録データが常に真実かつ正確な内容を反映するものであるように、適宜修正すること。\n\n万一上記に違反した場合又は真実かつ正確なデータが提供されていないと当社が判断した場合には、\n\n当社は顧客のIDを削除し、将来にわたって当社サービスを利用することをお断りする権利を有して\n\nおります。\n\n**第3条　顧客のID及びパスワードの管理**\n\n1. 顧客は、当社が顧客に付与するID、パスワード等の管理を行う責任を負うこととします。\n1. 顧客はID及びパスワード等を第三者に利用させ、又は譲渡もしくは担保設定その他の処分をすることはできないこととします。\n1. ID及びパスワード等の管理不十分、使用上の過誤、第三者の使用等による損害の責任は顧客が負うものとし、当社は一切の責任を負わないこととします。\n\n4.  顧客は、ID又はパスワードが第三者にもれた場合、あるいはID又はパスワードが第三者に使用され\n\nている疑いのある場合には、直ちに当社にその旨を連絡するとともに、当社の指示がある場合にはこ\n\nれに従うにこととします。この場合、当社はそのIDやパスワード等を不正アカウントとして停止する\n\nことができることとします。\n\n5.  パスワードの設定をしている顧客は、定期的にパスワードを変更する義務を負い、その義務を怠った\n\nことにより損害が生じても当社は一切の責任を負わないこととします。\n\n**第4条　顧客のID及びパスワードの削除**\n\n1.  当社が必要と判断した場合には、ID及びパスワードを削除し、サービスの利用を禁止し、サービス\n\n内のコンテンツを削除する権利を保有しています。この当社の権利は、顧客が本規約の内容又は趣\n\n旨に違反した、あるいは本規約の精神に照らして不適切な行為を行ったと当社が判断した場合など\n\nにも行使されますが、それらに限らず当社自身の裁量で行使いたします。\n\n2.  当社が必要と判断し特定の顧客に対してサービスの提供を中止する場合、当社は、当該顧客の顧客ID\n\n等を無効とし、関連する情報を削除するとともに、将来にわたって、当該情報、ファイル及びサ\n\nービスにアクセスすることを禁止することができることとします。この場合、当社はサービスの提\n\n供中止に関し、当該顧客及び第三者に対して一切責任を負わないこととします。\n\n**第5条　通知、連絡、又はメールマガジン等**\n\n顧客への通知又は連絡が必要であると当社が判断した場合には、当ウェブサイト上での掲示やメール\n\n又は郵便等、その他当社が適当と判断する方法を用いて行います。\n\n顧客は、当社が本サービスに関する案内、システムメンテナンスに関する告知、その他当社が適切と\n\n判断した情報を、Eメール等の手段により顧客に対して配信することを了承することとします。\n\n**第6条　個人情報の取り扱い**\n\n顧客登録情報及び当社が取得した顧客に関する情報は、別途定める当社のプライバシー・ポリシー\n\n（個人情報保護宣言）に従って取り扱われます。\n\n**第7条　サービスの変更、停止、及び廃止**\n\n当社は、いつでも本サービスの内容を事前の告知なく、変更又は廃止することができることとします。\n\n当社は、変更又は廃止により顧客に生じた損害には一切責任を負いません。\n\nまた、当社は、次の各号の事由により本サービスの一部又は全部を停止することができるものとし、\n\n当該停止により顧客に生じた損害には一切責任を負いません。\n\n1.  本サービスの提供のための装置、システムの保守又は点検を行う場合\n\n2.  火災、停電、地震、天災、システム障害等により、本サービスの運営が困難な場合\n\n3.  その他、当社がやむをえないと判断した場合\n\n**第8条　禁止行為**\n\n顧客が当社サービスを媒体として他人に開示又は提供するコンテンツに関する責任は、顧客自身が負\n\nいます。当社が顧客に代わって責任を負うことは一切ございません。また、当社は顧客が当社サービ\n\nスを媒介として他人に開示又は提供するコンテンツを管理したり、その内容の信頼性、真実性、適法\n\n性を保証したりすることは一切ございません。つまり、開示又は提供したコンテンツの内容によって\n\nは、顧客自身が損害賠償請求をされたり、第三者から異議を申し立てられたりする可能性があるとい\n\nうことをご理解いただく必要があります。当社はコンテンツの内容及び当該内容を使用したことに\n\n起因する損害については責任を負いません。上記の他、各種サービスの利用に伴い顧客とその関係者\n\n或いはそれ以外の第三者との間で生じるかもしれないいかなる種類の問題についても、当社はなんら\n\nの責任も負いません。顧客のみが自己の費用と責任でこれを解決するものとし、当社に一切の迷惑や\n\n損害を及ぼさないこととします。なお、上記の責務を果たしていただくために、当社は顧客による以下の行為を禁止いたします。\n\n1. 本サービスを不正の目的をもって利用する行為\n\n2. 当社の知的財産権、肖像権、パブリシティ権その他の権利を侵害する行為\n\n3. 当社の名誉もしくは信用を毀損し、又はプライバシーを侵害する行為\n\n4. 詐欺等の犯罪に結びつく行為\n\n5. コンピュータウイルスなど有害なプログラム等を送信もしくは提供する行為、又は推奨する行為\n\n6. 当社の情報を改ざん、消去する行為\n\n7. 当社の設備を不正に利用し、又はその運営に支障を与える行為\n\n8. 法令、本利用規約もしくは公序良俗に違反する行為\n\n9. 本サービスの運営を妨害する行為\n\n10. その他当社が不適当と判断する行為\n\n**第9条　免責事項**\n\n1. 当ウェブサイトの閲覧又は利用は、当ウェブサイトを閲覧又は利用する方の責任において行って頂きます。\n\n2. 当社は、当ウェブサイトが保有するサービス、コンテンツ、データ及び情報（以下「情報等」といいます。）の内容（真偽、正確性、合法性、有効性、道徳性、適時性、完全性、権利者からの利用許諾の有無、第三者の権利を侵害していないことを含む。）、提供の状態、アクセスの可能性、使用の状態については、保証するものではございません。また、当社は、当ウェブサイトの閲覧又は利用により生じた損害、並びに当ウェブサイトに含まれる情報等及び情報等に存在する遅滞、欠陥又は不作為から生じた損害について、責任を負いかねます。\n\n3. 顧客は、当ウェブサイトでの自らの行為において責任を負います。投稿等が法令違反や著作権等の権\n\n利侵害にあたる場合には、損害賠償などの民事責任の他、刑事責任を問われることがあります。法律\n\n又はユーザー利用規約の条項のいずれかに顧客が従わない場合には、顧客が当社に対して有する権利、\n\n主張、法的措置、訴訟、訴訟手続きの全てから当社を免除し、放免することとします。\n\n4. ウェブサイト運営者である当社は当ウェブサイトのサービスをいつでも任意の理由で中断することができます。当社は、当ウェブサイトの利用、又は利用ができないことによって引き起こされた（直接的、間接的を問わず）損害について、一切責任を負いません。\n\n**第10条　損害賠償の請求**\n\n顧客が本規約に反した行為又は不正もしくは違法に本サービスを利用することにより、当社に損害を\n\n与えた場合、当社は該当顧客に対して相応の損害賠償の請求（弁護士費用を含む）を行う場合がある\n\nこととします。\n\n**第11条　顧客各位の同意、法的手続き**\n\n1. 顧客は、当ウェブサイトを利用することにより、この利用規約すべての記載内容について、同意され\n\nたものとみなされます。またこの利用規約は当社の判断で任意に変更されます。将来引き続きご利用\n\nになる場合は、その時点での内容に同意されているとみなされます。\n\n2. この利用規約の準拠法は日本法とします。また、当ウェブサイト又はこの規約に関連して生じた紛争\n\nについては東京地方裁判所を第一審専属管轄裁判所といたします。\n\n**第12条　利用規約の変更**\n\n当社は、本利用規約を事前の承諾通知なく、変更することができることとします。当該変更の後、本\n\nサービスを利用した顧客は、かかる変更に同意したとみなされることとします。\n\n以上\n\n202x年〇月〇日制定\n\n`　`インスタキャッシュ株式会社'
                },
                {
                    showCheck: false,
                    isCheck: false,
                    text: '電磁的方法による書面交付に関する承諾書',
                    desc: 'インスタキャッシュ株式会社（以下「当社」といいます。）が、お客様に対して、金融商品取引法に基づいて行う書面の交付に代えて、以下のとおり当該書面に記載すべき事項を金融商品取引法、同法に関する政令及び内閣府令の規定に定める電磁的方法による交付（以下「電子交付」といいます。）の方法で行うことについてお客様は承諾するものとします。\n\n第１　電子交付の対象となる書面\n\n当社は、お客様と契約を締結するにあたっては、次の各号に掲げる書面を電子交付の方法によりご提供いたします。\n\n① 契約締結前交付書面\n\n② 匿名組合契約書\n\n③ 契約締結時交付書面\n\n④ 取引残高報告書\n\n⑤ 契約変更書面（変更すべき事項を記載した書面）\n\n⑥ その他当社が必要に応じてお客様に交付するレポート等の書面\n\n第２　電磁的方法の種類および内容（電子交付の種類および方式）\n\n１当社が行う電子交付の種類\n\n原則として以下の①または②の方法によるものし、必要に応じて③の方法をとる場合があります。\n\n1. 当社ウェブサイトからダウンロードする方法\n\n当社ウェブサイトにおいて書面の記載事項をお客様の閲覧に供し、お客様の使用に係る電子計算機（パソコン、携帯電話等）に備えられたファイルに当該記載事項をダウンロードして記録する方法\n\n1. 当社ウェブサイトに備えられた顧客ファイルを利用する方法\n\n当社ウェブサイトに、お客様専用ページ（パスワードによる認証が必要なマイページ）を設け、そのお客様のマイページに書面の記載事項を記録し、お客様の閲覧に供する方法\n\n1. 電子メールを利用する方法\n\n当社が電子メールを利用して、お客様の使用に係る電子計算機（パソコン、携帯電話等）に書面の記載事項を送信し、お客様が自己の電子計算機（パソコン、携帯電話等）に備えられたファイルに当該記載事項を記録する方法\n\n２ 当社が行う電子交付の方式　\n\n電子交付を受けるためには、当社が推奨するインターネットブラウザソフトおよびAdobe Reader等のPDF ファイル閲覧用ソフトを必要とします。\n\n`　`当社が推奨する上記のソフトについては当社ホームページ「サイトのご利用について」の「推奨環境」\n\n項に記載しております。推奨ソフト名およびそのバージョンについては下記URLをご参照ください。\n\nサイトのご利用について：https://○○.com\n\n第３免責事項\n\n１当社は、電磁的方法の種類および内容（電子交付の種類および方式）について、当社が電子交付を承\n\n`　`諾されたお客様の利用に際し支障をきたすおそれがないと判断した場合は、あらかじめ当社ウェブサ\n\nイト上に掲載、または電子メールで通知し、お客様に変更内容を明らかにすることにより、お客様の\n\n`　`同意を得ることなく、電磁的方法の種類および内容（電子交付の種類および方式）を変更することが\n\n`　`できるものとします。\n\n２お客様が電子交付を承諾された後であっても、法令等の変更や監督官庁の指示その他の必要な事態が\n\n`　`発生した場合等、何らかの理由が生じ、あるいは当社が必要と判断した場合には、当社は電子交付で\n\n`　`はなく、既に電子交付された書面も含めて紙媒体による書面の交付等を行う場合があります。\n\n３当社は、次の各号に掲げる事項により生じるお客様の損害については、一切の責任を負わないものと\n\nします。\n\n1. 通信機器・回線、コンピューター等のシステム機器等の障害・瑕疵ならびにこれらに関連した情報シ\n\nステム等の障害・瑕疵等により電子交付等が利用できないことにより生じた損害\n\n1. 天変地異、政変、同盟罷業等の不可抗力、その他当社の責に帰することがない事由により電子\n\n交付等サービスの提供が遅延し、または不能となったことにより生じた損害\n\n以上\n\n２０２ｘ年○月○日制定\n\nインスタキャッシュ株式会社'
                },
                {
                    showCheck: false,
                    isCheck: false,
                    text: 'プライバシーポリシー',
                    desc: 'インスタキャッシュ株式会社（以下「当社」といいます。）は、お客様個人を識別しうる情報（以下「個人情報」といいます。）の取扱方針を、あらかじめ分かりやすく説明することの重要性に鑑み、当社の個人情報保護に関する考え方および方針について、以下のとおりプライバシーポリシーとして定め、公表いたします。 \n\n**１．関係法令等の遵守** \n\n当社は、個人情報の取扱いについて、関係する法令諸規則およびその他規範等を遵守するとともに、当社の個人情報保護に関する諸規定等に従い、適正な管理を行い正確性・機密性の保持に努めます。 \n\n**２．個人情報の取得** \n\n当社は、お客様の個人情報を次の業務に関して取得いたします。 \n\n・金融商品取引法に基づく第二種金融商品取引業（以下「第二種金融商品取引業」といいます。）および当該業務に関連・付随する業務 \n\n・その他当社において行うことが認められた業務（将来、取扱いが認められる業務を含み\n\nます。） \n\n**３．個人情報の種類** \n\n当社は、**上記２**の業務を通じて、お客様に次の個人情報の提供をお願いすることがあります。 \n\n・氏名 \n\n・生年月日、年齢\n\n・性別 \n\n・郵便番号、住所\n\n・電話番号\n\n・電子メールアドレス\n\n・その他当社が行う業務に関係する情報 \n\n**４．個人情報の取得方法** \n\n（1） 当社は、適法かつ公正な次の手段によってお客様の個人情報を取得いたします。 \n\n・当社のウェブサイト、電話、ＦＡＸ、電子メールによるお問い合わせおよびご連絡 \n\n・お客様にご記載いただいた申込書、契約書その他の書類 \n\n・お客様からの口頭表現 \n\n（2） 当社は、お客様およびその関係者より直接ご提供いただく個人情報のほか、既に公にされているお客様の個人情報を利用する場合があります。 \n\n（3） 当社は、偽りその他不正の手段または手続きによりお客様の個人情報を取得するこ\n\nとはありません。 \n\n**５．個人情報の利用目的** \n\n（1） 当社は、お客様よりご提供いただいた個人情報を次の目的のために利用いたします。 \n\n・第二種金融商品取引業および当該業務に関連・付随する業務を行うため \n\n・金融商品（ファンド）、第二種金融商品取引業に関する情報を提供するため \n\n・取引時確認を行うため \n\n・お客様との間で安全かつ確実に業務を行うため \n\n・市場調査、データ分析、およびアンケートの実施等による金融商品（ファンド） やサー\n\nビスの研究や開発のため \n\n・当社および当社の海外の関連会社が適用ある国内および海外の法令等を遵守するため \n\n・犯罪およびテロ行為等の防止のため \n\n・お客様に対する業務上のご連絡を行うため \n\n（2） 当社は、お客様の個人情報について、利用目的の達成に必要な範囲を超えて取り扱\n\nうことはありません。 \n\n**６．利用目的の通知・公表の手続き** \n\n当社は、個人情報を取得した場合、その個人情報の利用目的が上記5に掲げる利用目的に\n\n該当しない場合は、速やかに、その利用目的をお客様ご本人に書面により通知または当社のウェブサイトにて公表いたします。 \n\n**７．機微（センシティブ）情報について** \n\n（1） 当社は、政治的見解、信教（宗教、思想および信条をいいます。）、労働組合への加盟、人種および民族、門地および本籍地、保健医療および性生活、ならびに犯罪歴に関する情報（以下「機微（センシティブ）情報」といいます。）については、金融庁が定める「金融分野における個人情報保護に関するガイドライン」に基づいて、同ガイドライン第6 条の例外事由に該当する場合を除いて、取得、利用または第三者提供を行いません。 \n\n（2） 当社が機微（センシティブ）情報を、同ガイドライン第6条に基づいて取得、利用または第三者提供する場合には、同ガイドライン第6条に掲げる例外事由を逸脱した取得、利用または第三者提供を行うことのないよう、特に慎重に取り扱うこととします。 \n\n**８．個人情報の開示・提供** \n\n当社は、お客様からご提供いただきました個人情報について、次のいずれかに該当する　場合を除いて、第三者に開示・提供することはありません。 \n\n・お客様が同意されている場合 \n\n・法令の定める例外事由に該当する場合 \n\n・当社がお客様にサービスを提供するために、当社にサービスを提供している第三者に情\n\n報提供する必要がある場合 \n\n**９．委託先による個人情報の取扱い** \n\n（1） 当社は、サービス提供に必要な手続き（ご本人確認等）、ご案内等の発送業務、定期報告書等の発送業務、情報システムの運用・保守に関わる業務など、個人情報の利用目的のために必要な範囲において、当社はお客様の個人情報の取扱いを第三者に委託することがあります。このような場合、当社は、当社に代わってお客様の個人情報を取り扱う第三者に厳重な管理を行わせます。 \n\n**１０．個人情報の管理** \n\n（1） お客様の個人情報を正確で最新のものにするよう適切な措置を講じます。 \n\n（2） お客様の個人情報の紛失、破壊、改ざんおよび漏洩等を防止するため、不正アクセス対策、コンピュータウイルス対策等の適切な情報セキュリティ対策を講じます。 \n\n（3） 当社に代わってお客様の個人情報の取扱い等を行う第三者にも同様に厳重な管理を行わせます。 \n\n**１１．お客様からの個人情報の開示・訂正、利用停止のご請求** \n\n（1） 開示・訂正 \n\n・当社は、お客様からご自身に関する個人情報の開示のご依頼があった場合は、請求者がご本人である事を確認させていただいたうえで特別な理由のない限りお答えいたます。 \n\n・お客様に関する個人情報が不正確である場合には、正確なものに変更させていただきます。 \n\n・開示の請求・訂正に関しましては、下記１２相談窓口までご連絡ください。 \n\n・この情報のご提供にあたり当社に発生した費用につきましては、お客様にご請求させていただく場合がありますのであらかじめご了承ください。 \n\n（2） 利用停止\n\n・ダイレクトメール、郵便物、電話、電子メール等によるご案内を希望されない場合は、下記１２の相談窓口までご連絡ください。 \n\n**１２．個人情報の取扱いに関する質問および苦情の相談窓口** \n\n個人情報の取扱いに関するご質問、ご意見、ご相談、お問い合わせ、苦情等につきましては、次の相談窓口までご連絡ください。当窓口にて適切に対応させていただきます。 \n\n**（相談窓口）**\n\nインスタキャッシュ株式会社 コンプライアンス部 \n\n〒150-0002 東京都渋谷区渋谷一丁目３番９号ヒューリック渋谷一丁目ビル６２４号室　\n\n電話番号：03－6778－8580（代表） \n\nＥメール:info@●●.jp \n\n受付時間 電話：9：00～18：00(土日祝日、年末年始の休業日を除きます。） \n\n**1３．クッキーの使用について** \n\n（1） 当社のウェブサイトはクッキーを使用しております。クッキーは、お客様の接続速度、オペレーションシステムの詳細、閲覧時間、IP アドレス等、お客様による当社ウェブサイトの使用に関する情報を収集します。クッキーが収集した情報によって、当社は、当社ウェブサイトの閲覧者数、セッションごとに閲覧されるページ、特定のページへの露出時間など、当社ウェブサイトの利用状況を理解することができます。それによって、ウェブサイトの内容に対する関心のレベルを評価し調整することで、お客様により満足していただけるウェブサイトをご提供いたします。 \n\n（2） 当社は、法律や規制によって要求される場合や当社または他のお客様の権利を保護する場合を除き、IP アドレスからお客様を特定しようとはいたしません。大多数のブラウザーは自動的にクッキーを受け入れますが、ブラウザーのオプション設定によって、クッキーを無効にすることができます。また、ブラウザーから既存のクッキーを削除することも可能です。ただし、クッキーを無効にした場合、当社サイトの一部が適切に機能しなくなる場合があります。 \n\n**１４．正確な情報提供のお願い** \n\nお客様の住所や氏名などの個人情報に変更が生じた場合は、必ず当社にお知らせください。 \n\n当社が記録を更新できるよう、お客様の個人情報の変更について、その内容が確認できる書類のコピーを添えて書面でお知らせくださるようお願いいたします。 \n\n**１５．プライバシーポリシーの変更** \n\nこのプライバシーポリシーは必要に応じて随時変更される可能性があります。当社が収集している情報、その用途およびどのような状況でそれを開示するかについてお客様が常に知ることができるように、変更後のプライバシーポリシーは、当社のウェブサイトにて公表いたします。 \n\n以上\n\n２０２ｘ年〇月〇日制定\n\nインスタキャッシュ株式会社'
                },
                {
                    showCheck: false,
                    isCheck: false,
                    text: '反社会的勢力に対する基本方',
                    desc: '当社は、暴力、威力と詐欺的手法を駆使して経済的利益を追求する集団または個人（いわゆる反社会的勢力）による被害を防止するために、次の基本方針を宣言します。\n\n\n1. 当社は、反社会的勢力との関係を一切持ちません。\n\n２． 当社は、反社会的勢力による被害を防止するために、警察・暴力追放運動推進\n\nセンター・弁護士等の外部専門機関と連携し、組織的かつ適正に対応します。\n\n３． 当社は、反社会的勢力による不当要求には一切応じず、毅然として法的対応しま\n\nす。\n\n４． 当社は、反社会的勢力への資金提供や裏取引を行いません。\n\n５． 当社は、反社会的勢力の不当要求に対応する役職員の安全を確保します。\n\n以上\n\n２０２✕年○月○日制定\n\nインスタキャッシュ株式会社'
                }
            ]
        };
    },

    mounted() {
        const {onValuesChange} = this;
        this.form = this.$form?.createForm(this, {
            name: 'stepInfo',
            onValuesChange
        });
        this.$store.commit('finance/updateFinance', {
            currentStepRouteName: 'RegisterStep1-1'
        });
    },

    methods: {
        onValuesChange(form, value, values) {
            if (!values) return;
            this.formData = values;
            const dataRight = Object.values(values).every(item => !!item);
            this.canSubmit = dataRight && this.agreementList.every(item => item.isCheck);
        },

        handleRead(idx) {
            this.agreementList[idx].showCheck = true;
            window.open(this.agreementList[idx].link);
        },

        onCheck(idx) {
            this.agreementList[idx].isCheck = !this.agreementList[idx].isCheck;
            this.onValuesChange(null, null, this.formData);
        },

        handleSubmit() {
            const {canSubmit} = this;
            if (!canSubmit) return;

            this.$store.commit('finance/updateFinance', {
                userEmail: 'xukejp@yahoo.co.jp'
            });
            this.$router.push({
                name: 'RegisterStep1-2'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep {
    .ant-radio-button-wrapper {
        height: unset;
        min-height: 32px;
    }
}

.register-left {
    max-width: 6.3rem;
    font-family: Noto Sans JP;
    font-size: 0.14rem;
    font-weight: 400;
    line-height: 0.22rem;
    color: $c-02;

    .title {
        font-family: Noto serif JP;
        font-size: 0.32rem;
        font-weight: 700;
        line-height: 0.42rem;
        color: $c-01;
    }

    .desc {
        margin-top: 0.24rem;
        display: flex;
        align-items: center;

        .icon {
            margin-left: 0.12rem;
            height: 0.36rem;
        }
    }

    .sub-tip-wrap {
        margin-top: 0.24rem;

        .fa-ren {
            margin-bottom: 0.04rem;
            display: flex;
            align-items: center;
            font-family: Noto Sans JP;
            font-size: 0.14rem;
            font-weight: 700;
            line-height: 0.22rem;
            color: #32302f;
        }

        .sub-tip {
            font-family: Noto Sans JP;
            font-size: 0.12rem;
            font-weight: 400;
            line-height: 0.19rem;
            color: #32302f;
        }
    }

    .form-wrap {
        margin-top: 0.6rem;

        .form {
            display: flex;
            flex-wrap: wrap;
        }
    }

    .agree-title {
        margin-bottom: 0.2rem;

        .title-left {
            font-family: Noto Sans JP;
            font-size: 0.16rem;
            font-weight: 400;
            line-height: 0.26rem;
        }

        .title-right {
            font-family: Noto Sans JP;
            font-size: 0.16rem;
            font-weight: 700;
            line-height: 0.26rem;
        }
    }

    .btn {
        border-radius: 0.12rem;
        margin-top: 0.4rem;
        width: 3rem;
        height: 0.52rem;
        background-color: $c-06;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Noto Sans JP;
        font-size: 0.16rem;
        font-weight: 700;
        line-height: 1;
    }

    .active {
        color: $c-09;
        background-color: $yellow-02;
    }

    .info {
        margin-top: 0.28rem;
        font-family: Noto Sans JP;
        font-size: 0.12rem;
        font-weight: 400;
        line-height: 0.19rem;
        color: $c-04;
    }
}

.red-circle {
    width: 0.24rem;
    height: 0.24rem;
    border-radius: 50%;
    background-color: #f66c70;
}

.tip {
    margin-bottom: 0.18rem;
    margin-top: 0.13rem;
    color: #fff;
    font-family: Noto Sans JP;
    font-size: 0.2rem;
    font-weight: 700;
    line-height: 0.26rem;

    .red {
        color: #f66c70;
    }
}

.tip-list {
    position: relative;
    font-family: Noto Sans JP;
    font-size: 0.18rem;
    font-weight: 400;
    line-height: 0.29rem;
    box-sizing: border-box;
    padding-left: 0.2rem;

    &::before {
        content: "・";
        color: #fff;
        font-size: 0.18rem;
        position: absolute;
        left: 0.04rem;
        top: 0;
    }
}
</style>
